import { render, staticRenderFns } from "./ProjectBasicCharacteristics.vue?vue&type=template&id=523c3f8a&scoped=true&"
import script from "./ProjectBasicCharacteristics.vue?vue&type=script&lang=js&"
export * from "./ProjectBasicCharacteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c3f8a",
  null
  
)

export default component.exports